import {useEffect, useState} from "react"
import {
    fetchDealerReport,
    fetchRegionReport,
    setPRDateRangeFilter,
} from "../../../../containers/PassRate/passRateReportSlice"
import {useAppDispatch, useAppSelector} from "../../../../store"
import {DateRangePicker, DateRangePickerChangeEvent, SelectionRange} from "@progress/kendo-react-dateinputs"
import {RootState} from "../../../../rootReducer"
import {Button} from "@progress/kendo-react-buttons"

const PassRateReportFilter = () => {
    const dispatch = useAppDispatch()
    const prDateRangeFilter = useAppSelector(
        (state: RootState) => state.containers.passRateReport.summaryDateRangeFilter,
    )
    const [dateRange, setDateRange] = useState<SelectionRange>(prDateRangeFilter)
    const [dateValidation, setDateValidation] = useState(dateRange.start !== null && dateRange.end !== null)
    const regionReportLoading = useAppSelector(
        (state: RootState) => state.containers.passRateReport.prRegionReportLoader,
    )
    const dealerReportLoading = useAppSelector(
        (state: RootState) => state.containers.passRateReport.prDealersReportLoader,
    )

    useEffect(() => {
        getReports()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onDateChange = (e: DateRangePickerChangeEvent) => {
        setDateValidation(e.value.start !== null && e.value.end !== null)
        setDateRange(e.value)
        dispatch(setPRDateRangeFilter(e.value))
    }

    const getReports = () => {
        dispatch(fetchDealerReport(dateRange))
        dispatch(fetchRegionReport(dateRange))
    }

    return (
        <div className="row align-items-end mb-2">
            <div className="col-4 col">
                <DateRangePicker valid={dateValidation} value={dateRange} onChange={onDateChange} />
            </div>
            <div className="col">
                <Button
                    type="submit"
                    fillMode={"flat"}
                    themeColor="primary"
                    onClick={getReports}
                    disabled={!dateValidation || regionReportLoading || dealerReportLoading}
                >
                    Go
                </Button>
            </div>
        </div>
    )
}

export default PassRateReportFilter
